import types from './types';

export const socialConnection = (options) => ({type: types.SOCIAL_CONNECTION, options});
export const loginUsernamePassword = ({username, password, redirect, ...options}) => ({
    type: types.LOGIN_USERNAME_PASSWORD,
    redirect,
    username,
    password,
    options
});
export const handleLogin = ({accessToken, idToken, expiresIn}) => ({
    type: types.LOGGED,
    accessToken,
    idToken,
    expiresIn,
});
export const alreadyLogged = () => ({type: types.ALREADY_LOGGED_IN});
export const loginError = (error) => ({type: types.ERROR_LOGIN, error});
export const signUp = ({email, password, redirect, ...options}) => ({
    type: types.SIGNUP,
    redirect,
    email,
    password,
    options
});
export const signUpData = ({email, first_name, last_name}) => ({
    type: types.SIGNUP_DATA,
    payload: {email, first_name, last_name}
});
export const signUpError = (error) => ({type: types.ERROR_SIGNUP, error});

export const logout = () => ({type: types.LOGOUT});
export const logoutError = (error) => ({type: types.ERROR_LOGOUT, error});

export const recoverPassword = ({email, ...options}) => ({type: types.RECOVER_PASSWORD, email, options});